import DashboardExportContainer from "../containers/DashboardExportContainer";
import React from "react";

export const DashboardExportPage: React.FunctionComponent = () => <DashboardExportContainer />;